import React from 'react';
import { Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { RevolvingDot } from 'react-loader-spinner';
import { useDownloadExcel } from 'react-export-table-to-excel';
import { Download } from '@mui/icons-material';
import { useRef } from 'react';

const DHQTable = () => {

    const tableRef = useRef(null);

    const { onDownload } = useDownloadExcel({
        currentTableRef: tableRef.current,
        filename: "Foundation",
        sheet: "C5"
    });


    const headings = [
        {
            id: 'Date',
            numeric: false,
            disablePadding: true,
            label: 'Date',
        },
        {
            id: 'Receiver',
            numeric: false,
            disablePadding: false,
            label: 'Receiver',
        },
        {
            id: 'Purpose',
            numeric: false,
            disablePadding: false,
            label: 'Purpose',
        },
        {
            id: 'Sub Purpose',
            numeric: false,
            disablePadding: false,
            label: 'Sub Purpose',
        },
        {
            id: 'Description',
            numeric: false,
            disablePadding: false,
            label: 'Description',
        },
        {
            id: 'Sub Description',
            numeric: false,
            disablePadding: false,
            label: 'Sub Description',
        },
        {
            id: 'Spent By',
            numeric: false,
            disablePadding: false,
            label: 'Spent By',
        },
        {
            id: 'Amount',
            numeric: true,
            disablePadding: false,
            label: 'Amount',
        },
        {
            id: 'Posting Time',
            numeric: true,
            disablePadding: false,
            label: 'Posting Time',
        },
    ];

    const dhqStatementURL = 'http://localhost:5000/getDhqStatement';

    const { data: rows, isLoading } = useQuery({
        queryKey: ['Expenses'],
        queryFn: async () => {
            const response = await fetch(dhqStatementURL);
            const data = await response.json();
            return data;
        }
    });

    const subTotal = (array) => {
        const total = array?.map(({ amount }) => amount).reduce((sum, i) => sum + i, 0);
        return total;
    };

    const invoiceSubtotal = subTotal(rows);






    if (isLoading) {
        return (
            <div>
                <div>
                    <RevolvingDot
                        height="600"
                        width="600"
                        radius="60"
                        color="#4fa94d"
                        secondaryColor=''
                        ariaLabel="revolving-dot-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                        visible={true}
                    />
                    <h3>Please Wait.</h3>
                    <h3>System is working on your command of loading data from database.</h3>
                    <h3>Loading time depends on data size.</h3>
                    <h3>Untill loading finished, please stay with us. </h3>
                </div>
            </div>
        )
    };


    return (
        <div>

            <Button onClick={onDownload} color='success' variant='contained' endIcon={<Download />} sx={{ my: 2 }} >Export to Excel</Button>
            <TableContainer>

                <Table ref={tableRef}>

                    <TableHead>

                        <TableRow>

                            {headings?.map((heading) => (
                                <TableCell
                                    key={heading.id}
                                    align="center"
                                    padding={heading.disablePadding ? 'none' : 'normal'}

                                >
                                    <TableSortLabel  >
                                        {heading.label}
                                    </TableSortLabel>
                                </TableCell>
                            ))}

                        </TableRow>

                    </TableHead>

                    <TableBody>

                        {
                            rows?.map(row =>
                                <TableRow hover>

                                    <TableCell align="left"> {row.date} </TableCell>
                                    <TableCell align="left">{row.receiver}</TableCell>
                                    <TableCell align="left">{row.purpose}</TableCell>
                                    <TableCell align="left">{row.subPurpose}</TableCell>
                                    <TableCell align="left">{row.description}</TableCell>
                                    <TableCell align="left">{row.subDescription}</TableCell>
                                    <TableCell align="left">{row.spentBy}</TableCell>
                                    <TableCell align="right">{row.amount}</TableCell>
                                    <TableCell align="right">{row.postingTime}</TableCell>
                                </TableRow>
                            )
                        }

                        <TableRow hover>

                            <TableCell colSpan={5} />
                            <TableCell colSpan={2}>Subtotal</TableCell>
                            <TableCell align="right">{(invoiceSubtotal)}</TableCell>
                        </TableRow>

                    </TableBody>

                </Table>

            </TableContainer>

        </div>
    );
};

export default DHQTable;